import { h } from 'preact';
import { useState } from 'preact/hooks';

export default function App() {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');

  const handleSubmit = () => {
    const cleanedText = inputText
      .replace(/[^a-zA-Z0-9]+/g, ' ') // Replace non-alphanumeric characters with space
      .replace(/\s+/g, ' ')          // Collapse multiple spaces into one
      .trim();                        // Remove leading/trailing spaces
    setOutputText(cleanedText);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(outputText);
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Remove Invalid Characters</h1>
      <textarea
        rows={6}
        style={{ width: '100%', padding: '0.5rem', fontSize: '1rem' }}
        placeholder="Enter your text here"
        value={inputText}
        onInput={(e) => setInputText(e.target.value)}
      />
      <button onClick={handleSubmit} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
        Submit
      </button>

      {outputText && (
        <div style={{ marginTop: '2rem' }}>
          <h2>Cleaned Output</h2>
          <textarea
            readOnly
            rows={4}
            style={{ width: '100%', padding: '0.5rem', fontSize: '1rem' }}
            value={outputText}
          />
          <button onClick={handleCopy} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
            Copy Output
          </button>
        </div>
      )}
    </div>
  );
} 
